import React from 'react';
import * as d3 from 'd3';

const Arc = ({ data, index, createArc, colors, format, svg }) => {
  return (
    <g key={index} className='arc'>
      <path className='arc' d={createArc(data)} fill={colors[data.data.label]} radius={10} />
      {format(data.value)}
    </g>
  );
};

const ActivityChart = (props) => {
  const width = 260;
  const height = 260;
  const radius = Math.min(width, height) / 2;
  const innerRadius = radius - 25;

  const createPie = d3
    .pie()
    .value((d) => d.value)
    .sort(null);
  const createArc = d3.arc().innerRadius(innerRadius).outerRadius(radius);
  const format = d3.format('.2f');
  const data = createPie(props.data);
  const svg = d3.select('#' + props.chartId);

  //let total = props.data.find(x => x.label === 'target')
  return (
    <svg id={props.chartId} height={height} width={width}>
      <g transform={`translate(${radius} ${radius})`}>
        {data.map((d, i) => (
          <Arc key={i} data={d} index={i} createArc={createArc} colors={props.colorset} format={format} svg={svg} />
        ))}
      </g>
    </svg>
  );
};

export default ActivityChart;
